<div class="main row">
  <div class="column twelve">
    <p class="pad-top-20 pad-bottom-10" dsContent [contentPath]="'policy.policyLandingTitle'"></p>
    <hr aria-hidden="true" />
    <h3 dsContent [contentPath]="'policy.policyLandingViewPolicies'"></h3>
    @if (hasSecurityQuestions | async) {
      <div>
        <p class="pad-top-20" dsContent [contentPath]="'policy.personalLinesPolicyText'"></p>
        <p class="pad-top-20" dsContent [contentPath]="'policy.personalLinesPolicyNote'"></p>
      </div>
    }
    <div class="pad-top-20 flex float-left">
      @if (hasSecurityQuestions | async) {
        <button
          ds-button
          class="-outline-white"
          type="button"
          (click)="addPersonalLine()"
          data-cy="primaryButton"
          class="margin-right-10"
          dsContent
          [contentPath]="'policy.addAutoBtn'"
        ></button>
      }
      <button
        ds-button
        class="white -outline"
        type="button"
        (click)="requestQuote()"
        data-cy="secondaryButton"
        dsContent
        [contentPath]="'policy.requestQuoteBtn'"
      ></button>
    </div>
  </div>
</div>
